/**
 * <strong>Purpose:</strong> <br><br>
 * Provides the ability to format the value property
 * <br><br>
 * <strong> Property Dependencies </strong> <br><br>
 * <li> value </li> <br><br>
 * <strong> Mixin Dependencies </strong> <br><br>
 * <li> dijit/_FocusMixin </li> <br><br>
 * @module mw-form/mixins/property/FormatMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dijit/_FocusMixin"
], function (declare, lang, _FocusMixin) {

    var FormatMixin = declare(null, {

        /**
         * @property  {string} format - String like "%d", "%f" etc
         * @instance
         * @default ""
         */
        format: "",

        constructor: function() {
            /**
             * @property  {function} displayValueFormatter - This callback can be provided to do custom formatting that 'format' property doesn't support
             * @instance
             * @default
             */
            this.displayValueFormatter = null;
        },

        postCreate: function () {
            this.inherited(arguments);
            this.domNode.classList.add("mwFormatMixin");
            //When the default value is falsy, the setter will not be triggered during the widget's construction phase
            // We need to call the setter explicitly
            this.set("format", this.get("format"));
        },

        startup: function () {
            this.inherited(arguments);
            this._handleDisplayFormat();
        },

        _setFormatAttr: function (format) {
            if (typeof format !== "string") {
                return new Error("Format property expects a ''string");
            }
            this._set("format", format);
            this._handleDisplayFormat();
        },

        _handleDisplayFormat: function () {
            var format = this.get("format");
            var value = parseFloat(this._textField.get("value"));
            //If value is String => NAN
            if (value || value === 0) {

                if (format.match('%*[0-9|.]d') || format.indexOf("%i") >= 0) {
                    this._textField.setValueInDom(parseFloat(value).toFixed(4) +
                        format.substr(format.indexOf("d") + 1, format.length));
                    //Have '% any digits or .' followed by f
                } else if (format.match('%*[0-9|.]f')) {
                    /* Find characters between . and f*/
                    /* 0.3f => 3 */
                    var re = /(.*\.)(.*)(f.*)/;
                    var precision = parseFloat(format.replace(re, "$2"));
                    // %10f returns precision as NAN
                    //g2164877 - if Nan then use precision 0
                    // if no precision returned then assume precision = 0
                    if (!precision) {
                        precision = 0;
                    }

                    this._textField.setValueInDom(value.toFixed(precision) +
                        format.substr(format.indexOf("f") + 1, format.length));

                } else {
                    if (this.displayValueFormatter) {
                        this.displayValueFormatter(this.get("value")).then(lang.hitch(this,
                            function (data) {
                                this._textField.setValueInDom(data);
                            }));
                    }
                }
            }
        },
        _onBlur: function () {
            this.inherited(arguments);
            if (this.get("validationState") === "normal") {
                this._handleDisplayFormat();
            }
            //For spinner tester purpose only
            this._formattedValueSet = true;
        },
    });
    FormatMixin._dependencies = [
        {mixin: _FocusMixin, orderDependent: false}
    ];
    return FormatMixin;
});
